import { createSlice } from '@reduxjs/toolkit';

const selectedDistrictsSlice = createSlice({
    name: 'SelectedDistricts',
    initialState: {
        selectedDistricts: []
    },
    reducers:{
        setSelectedDistricts: (state, action) => {
            state.selectedDistricts = action.payload
        }
    }
})

const selectedGenderSlice = createSlice({
    name: 'SelectedGender',
    initialState: {
        selectedGender: 'all'
    },
    reducers:{
        setSelectedGender: (state, action) => {
            state.selectedGender = action.payload
        }
    }
})

export const {setSelectedDistricts} = selectedDistrictsSlice.actions
export const selectedDistrictsReducer = selectedDistrictsSlice.reducer

export const {setSelectedGender} = selectedGenderSlice.actions
export const selectedGenderReducer = selectedGenderSlice.reducer